export enum UserRoleEnum {
  Admin = 1,
  Practitioner = 2,
  Client = 3,
  Receptionist = 4,
  Clinicmaster = 5,
  External = 6,
  'Addatech Admin' = 7,
}
